<template>
    <td class="tableButtons">
        <router-link
            v-tooltip="'View item'"
            v-if="view"
            :to="view"
            class="iconButton"
        >
            <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        </router-link>
        <router-link
            v-tooltip="'Edit item'"
            v-if="edit"
            :to="edit"
            class="iconButton"
        >
            <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"/><path d="M18 2l4 4-10 10H8v-4L18 2z"/></svg>
        </router-link>
        <button
            v-tooltip="'Restore item'"
            v-if="showRestore"
            type="button"
            class="iconButton"
            @click="$emit('restore')"
        >
            <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
        </button>
        <button
            v-tooltip="'Remove item'"
            v-if="showDelete"
            type="button"
            class="iconButton"
            @click="$emit('delete')"
        >
            <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M10 11v6M14 11v6"/></svg>
        </button>
    </td>
</template>

<script>
export default {
    props: {
        view: {
            type: String,
            default: null,
        },
        edit: {
            type: String,
            default: null,
        },
        showRestore: {
            type: Boolean,
            default: false,
        },
        showDelete: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="postcss" scoped>
.tableButtons {
    text-align: right;
    max-width: 120px;
    min-width: 120px;
}
.iconButton {
    margin-left: 12px;
    cursor: pointer;
    color: var(--grey600);
    transition: 0s;
    display: inline-block;
    line-height: 0;
    &:hover {
        color: var(--primary);
    }
}
.iconButton .icon {
    transition: var(--normalTrans);
    width: 20px;
    height: 20px;
    @media (--laptop) {
        width: 18px;
        height: 18px;
    }
}
</style>
